import Hero from "../components/Hero/Hero";
import Portfolio from "../components/Portfolio/Portfolio";
import Testimonials from "../components/Testimonials/Testimonials";
import Showcase from "../components/Showcase/Showcase";
import { resume } from "../assets/data/Resume";
import ScrollToTop from "../utils/ScrollToTop";
import Techs from "../components/Techs/Techs";

function Home() {
    ScrollToTop();
    return (
        <>
            <Hero />
            <Portfolio />
            <Techs />
            <Testimonials />
            <Showcase {...resume} />
        </>
    );
}

export default Home;
